import template from './unprocessed-operations.hbs'
import Unprocessed from './unprocessed'

/**
 * Dialog displaying unprocessed background process operations (#24189)
 */
const UnprocessedOperations = Unprocessed.extend({

	template,
	unprocessedDescKey: 'admin.backgroundProcessStatus.unprocessedCommands'

})

export default UnprocessedOperations

UnprocessedOperations.__filename__ = 'admin/background-processes/unprocessed-operations.js'
